<template lang="pug">
  main
    NavBarAdmin
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Aplicaciones Gerencia General Ductos y Terminales
            br
        .columns.has-text-centered.is-centered.is-multiline.has-text-black.is-mobile
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold IRGE
                br
                a.button.is-dark.is-rounded(@click="irApartado('IRGE')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold TPA
                br
                a.button.is-dark.is-rounded(@click="irApartado('TPA')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold CORPO
                br
                a.button.is-dark.is-rounded(@click="irApartado('CORPO')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold DUCTO
                br
                a.button.is-dark.is-rounded(@click="irApartado('DUCTO')") Entrar
        .columns.has-text-centered.is-centered.is-multiline.has-text-black.is-mobile
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold ACTIVOS
                br
                a.button.is-dark.is-rounded(@click="irApartado('Activos')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold AUDITORIA
                br
                a.button.is-dark.is-rounded(@click="irApartado('Auditoria')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold GIA
                br
                a.button.is-dark.is-rounded(@click="irApartado('GIA')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold CAPITAL HUMANO
                br
                a.button.is-dark.is-rounded(@click="irApartado('RH')") Entrar
          .column.is-3-desktop.is-4-mobile
            .card
              .card-content
                p.has-text-weight-bold SASISOPA
                br
                a.button.is-dark.is-rounded(@click="irApartado('SASISOPA')") Entrar
        .columns.column-blanco
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarAdmin from '@/components/layout/NavBarAdmin.vue'
import NotificacionConst from '@/components/shared/NotificacionConst.vue'
import { mapState } from 'vuex'
import InventarioServices from '@/services/inventario/inventario'
import ticketServices from "@/services/soporte/tickets"

export default {
  name: 'HomeAdmin',
  components: { Loader, NavBarAdmin, NotificacionConst },
  data () {
    return {
      isLoading: false,
      textosNotificaciones: [
        {titulo: 'En contrucción', fecha: '22/09/2020', texto: 'Act.', tipo: 'c'},
        {titulo: 'En proyecto', fecha: '22/09/2020', texto: 'Act.', tipo: 'pr'},
        {titulo: 'En pruebas', fecha: '22/09/2020', texto: 'Act.', tipo: 'p'}
      ]
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      }
      //this.checkSolicitudesPendientes()
      //this.checkRequisicionesPendientes()
      if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3 || this.userLogin.departamento === 6) {
        this.checkTickets()
      }
    },
    irSca () {
      location.href = '/SCA_Tuxpan/principal.html'
    },
    irReportes () {
      location.href = '/reportesApp/home.html'
    },
    irMonitoreo () {
      console.log('Ir a monitorear' + this.estacionSel)
      this.$router.push('/Monitor')
    },
    checkSolicitudesPendientes () {
      switch (this.userLogin.categoria) {
        case 0:
          console.log('gerentes')
          if (this.userLogin.cargo === '000') {
            InventarioServices.getSolicitudes_All('ALL')
            .then( res => {
              // let sol_depto = res.filter( sol => parseInt(sol.estado) == 2 || parseInt(sol.estado) == 4)
              let sol_depto = res.filter( sol => parseInt(sol.estado) == 4 )
                if ( sol_depto.length > 0 ) {
                  this.displayToast(sol_depto.length)
                }
            })
          } else {
            InventarioServices.getSolicitudes_ubicacion(this.userLogin.ubicacion, 'ALL')
            .then( res => {
              let sol_depto = res.filter( sol => parseInt(sol.estado) >= 4)
                if ( sol_depto.length > 0 ) {
                  this.displayToast(sol_depto.length)
                }
            })
          }
          break
        case 2:
          console.log('jefes de area')
          InventarioServices.getSolicitudes_depto(this.userLogin.departamento, 'ALL')
            .then( res => {
              console.log(res)
              let sol_depto = res.filter( sol => sol.estado === '1' && sol.ubicacion === this.userLogin.ubicacion)
                if ( sol_depto.length > 0 ) {
                  this.displayToast(sol_depto.length)
                }
            })
          break
        default:
          break
      }
    },
    checkRequisicionesPendientes() {
      if (this.userLogin.ubicacion === 'ALL') {
        InventarioServices.getRequisiciones_Ubicaciones('ALL', 3)
          .then( res => {
            let pendientes = res[0].pendientes
            if ( pendientes > 0) {
              let strPend = pendientes == 1? 'Requisición Pendiente' : 'Requisiciones Pendientes'
              let mensaje = `${pendientes} ${strPend}`
              this.displayToast(mensaje,'done','Ir a Combustible', '/Requisciones')
            }
          })
      }
    },
    checkTickets() {
      ticketServices.searchAll()
        .then((data) => {
          console.log(data)
          let ticketsPend = data.filter((tick) => parseInt(tick.estado) >= 3).length
          console.log(ticketsPend)
          this.sendNotification_tickets(ticketsPend)
        })
        .catch((e)=> {
          this.displayToast(e.message,'ban','Ok','')
        })
    },
    sendNotification_tickets(ticketsPend) {
      if (ticketsPend > 0) {
        let textToast = ''
        if (ticketsPend == 1) {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} ticket pendiente.`
        } else {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} tickets pendientes.`
        }
        this.displayToast(textToast,'done','Ir a Soporte','/Soporte')
      }
    },
    displayToast(message, icon, actionText, destiny) {
      let toast = this.$toasted.show(message, {
        theme: "toasted-primary",
        position: "bottom-right",
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            console.log(destiny)
            this.$router.push(destiny)
            toastObject.goAway(0)
          }
        },
      })
    },
    irApartado (dest) {
      this.$store.commit('irEstaciones', dest)
      this.$router.push(`/Apartado/${dest}`)
    },
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  },
  created () {
    this.obtenerUser()
  },
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }

  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
  .card {
    color: #54545c;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomeAdmin.vue